import styles from "./SectionBanner.module.css";
import aboutUsBannerImage from "../../assets/images/somos/62335684-944e-444b-9170-60383115afce 1.png";
import okIcon from "../../assets/images/somos/ok.png";

const SectionBanner = () => {
  return (
    <section className={styles.banner}>
      <div className={styles.leftColumn}>
        <div className={styles.textContent}>
          <h2 className={styles.title}>Nosotros</h2>
          <p className={styles.subtitle}>
            Más de 30 años de servicio y experiencia en publicidad en el sector
            transportista.
          </p>

          <div className={styles.features}>
            <div className={styles.featureItem}>
              <img src={okIcon} alt="Atención" loading="lazy" />
              <span>Atención Personalizada</span>
            </div>
            <div className={styles.featureItem}>
              <img src={okIcon} alt="Cobertura" loading="lazy" />
              <span>Cobertura Promocional Nacional</span>
            </div>
            <div className={styles.featureItem}>
              <img src={okIcon} alt="Diseño" loading="lazy" />
              <span>Diseño</span>
            </div>
            <div className={styles.featureItem}>
              <img src={okIcon} alt="Proyección" loading="lazy" />
              <span>Proyección de Imagen</span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.rightColumn}>
        <img
          src={aboutUsBannerImage}
          alt="Nosotros Banner"
          className={styles.image}
        />
      </div>
    </section>
  );
};

export default SectionBanner;
